import React from "react";

export const ToggleButton = (props: any) => {
  const { onChange, value, onBlur, id, name, toggleStyle, disabled } = props;
  return (
    <span className="flex items-center">
      <label className="relative inline-flex items-center cursor-pointer">
        <input
          onChange={onChange}
          id={id}
          name={name}
          onBlur={onBlur}
          type="checkbox"
          checked={value}
          disabled={disabled}
          defaultChecked={value}
          className="sr-only peer"
        />
        <div
          className={`w-[36px] h-[20px] bg-[#D4D4D4] rounded-full peer peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-white after:border after:rounded-full after:h-[16px] after:w-[16px] after:transition-all peer-checked:bg-[#02BF59] ${disabled ? "cursor-not-allowed opacity-50" : "cursor-pointer"} ${toggleStyle}`}
        />
      </label>
    </span>
  );
};
